import { render, staticRenderFns } from "./ModelListItemSimpleCard.vue?vue&type=template&id=3cf77660&scoped=true"
import script from "./ModelListItemSimpleCard.vue?vue&type=script&lang=js"
export * from "./ModelListItemSimpleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf77660",
  null
  
)

export default component.exports